import { render, staticRenderFns } from "./SplitView.vue?vue&type=template&id=152e31b8&scoped=true&"
import script from "./SplitView.vue?vue&type=script&lang=ts&"
export * from "./SplitView.vue?vue&type=script&lang=ts&"
import style0 from "./SplitView.vue?vue&type=style&index=0&id=152e31b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152e31b8",
  null
  
)

export default component.exports